export const styles = {
  container: {},
  errorWrapper: { marginBottom: "0.5rem" },
  header: { marginLeft: 0 },
  backIconRoot: { fontSize: "small" },
  title: { marginLeft: "1rem" },
  requiredNote: { marginBottom: "16px" },
  requiredText: { root: { fontSize: "11px", color: "#a19f9d", fontStyle: "italic" } },
  form: {},
  section: { marginBottom: "32px" },
  sectionTitle: {
    root: {
      fontSize: "13px",
      fontWeight: "600",
      color: "#323130",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginBottom: "8px",
    },
  },
  divider: {
    height: "1px",
    backgroundColor: "#edebe9",
    marginBottom: "16px",
  },
  sectionTabs: {
    gap: 0,
    marginBottom: "8px",
    borderBottom: "1px solid #edebe9",
  },
  sectionTab: {
    padding: "8px 16px 10px",
    marginBottom: "-1px",
    border: "none",
    background: "none",
    cursor: "pointer",
    borderBottom: "2px solid transparent",
    font: "inherit",
    color: "#605e5c",
  },
  sectionTabActive: {
    color: "#323130",
    fontWeight: 600,
    borderBottomColor: "#0078d4",
  },
  actionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    paddingTop: "24px",
  },
  primaryButton: {
    root: {
      backgroundColor: "#0078d4",
      color: "white",
      border: "1px solid #0078d4",
      borderRadius: "4px",
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "600",
      "&:hover": {
        backgroundColor: "#106ebe",
      },
      "&:disabled": {
        backgroundColor: "#f3f2f1",
        color: "#a19f9d",
        borderColor: "#d2d0ce",
      },
    },
  },
  secondaryActions: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    marginLeft: 0,
    marginBottom: "12px",
  },
  secondaryButton: {
    root: {
      backgroundColor: "transparent",
      color: "#0078d4",
      border: "1px solid #0078d4",
      borderRadius: "4px",
      padding: "6px 12px",
      fontSize: "13px",
      "&:hover": {
        backgroundColor: "#f3f9fd",
      },
      "&:disabled": {
        backgroundColor: "transparent",
        color: "#a19f9d",
        borderColor: "#d2d0ce",
      },
    },
  },
  tertiaryButton: {
    root: {
      backgroundColor: "transparent",
      color: "#605e5c",
      border: "none",
      padding: "6px 12px",
      fontSize: "13px",
      textDecoration: "underline",
      "&:hover": {
        backgroundColor: "#f3f2f1",
        textDecoration: "underline",
      },
    },
  },
  bottomButtons: {},
  rightButtons: {},
  loadingWrapper: {},
};
